/**
 * Session VWAP adapter for the chart chassis.
 * Converts the null-padded array from calcSessionVWAP into LWC {time,value} format.
 *
 * @param {Array<{time:number, open:number, high:number, low:number, close:number, volume:number, rawEpochMs?:number}>} bars
 * @param {string} resetType  '1day' | '2day' | 'wtd' | 'mtd' | 'ytd'
 * @param {{ id:string, holidays?: Array<string|{date:string}> } | null} [tradingCalendar]
 *   CE-04g-UI-vwap-anchor: forwarded to calcSessionVWAP only for the 'wtd'
 *   reset (post-holiday-Monday anchoring). All other reset types ignore it.
 * @returns {Array<{time:number, value:number}>}
 */
import { calcSessionVWAP } from '../indicators.js'

export function computeSessionVWAP(bars, resetType, tradingCalendar) {
  if (!Array.isArray(bars) || bars.length === 0) return []
  const raw = calcSessionVWAP(bars, resetType, tradingCalendar)
  const out = []
  for (let i = 0; i < bars.length; i++) {
    if (raw[i] != null && Number.isFinite(raw[i]) && Number.isFinite(bars[i].time)) {
      out.push({ time: bars[i].time, value: raw[i] })
    }
  }
  return out
}
